import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { AlertController, Events } from 'ionic-angular';
import { Network } from '@ionic-native/network';
import { environment } from '../environments/environment';

export enum ConnectionStatusEnum {
  Online,
  Offline
}

@Injectable()
export class NetworkServices {

  public static previousStatus = ConnectionStatusEnum.Online;

  constructor(public http: HttpClient, 
    private storage: Storage, 
    public alertCtrl: AlertController, 
    public network: Network,
    public eventCtrl: Events) {
      this.http.get<any>(`${environment.ismUrl}`)
        .subscribe((res) => {
          if(res.status == 200){
            console.log("you're online");
          }else{
            this.setOffline();
            console.log("you're offline");
          }
        }, (error) => {
          if(error.status == 200){
            console.log("you're online");
          }else{
            this.setOffline();
            console.log("you're offline");
          }
        });
  }

  public initializeNetworkEvents(): void {
    this.network.onDisconnect().subscribe(() => {
      if (NetworkServices.previousStatus === ConnectionStatusEnum.Online) {
        this.eventCtrl.publish('network:offline');
      }
      NetworkServices.previousStatus = ConnectionStatusEnum.Offline;
    });
    this.network.onConnect().subscribe(() => {
      if (NetworkServices.previousStatus === ConnectionStatusEnum.Offline) {
        this.eventCtrl.publish('network:online');
      }
      NetworkServices.previousStatus = ConnectionStatusEnum.Online;
    });
  }

  get(url: string, auth: any, params: string = ""){
    if(this.isOnline()){
      console.log('online');
      
      return this.http.get<any>(this.getUrl(url, auth)+params)
      .toPromise();
    }else if(this.isOffline()){
      console.log('offline');
      
      return Promise.reject('offline');
    }
  }
  
  post(url: string, auth: any, data?: any){
    if(this.isOnline()){
      return this.http.post<any>(this.getUrl(url, auth), data)
      .toPromise();
    }else if(this.isOffline()){
      return Promise.reject('offline');
    }
  }

  put(url: string, auth: any, data?: any){
    if(this.isOnline()){
      return this.http.post<any>(this.getUrl(url, auth), data)
      .toPromise();
    }else if(this.isOffline()){
      return Promise.reject('offline');
    }
  }

  delete(url: string, auth: any, data?: any){
    if(this.isOnline()){
      return this.http.post<any>(this.getUrl(url, auth), data)
      .toPromise();
    }else if(this.isOffline()){
      return Promise.reject('offline');
    }
  }

  isOnline(){
    // return true;
    if(NetworkServices.previousStatus === ConnectionStatusEnum.Online){
      return true;
    }else{
      return false;
    }
  }

  isOffline(){
    // return false;
    if(NetworkServices.previousStatus === ConnectionStatusEnum.Offline){
      return true;
    }else{
      return false;
    }
  }

  setOffline(){
    if (NetworkServices.previousStatus === ConnectionStatusEnum.Online) {
      this.eventCtrl.publish('network:offline');
    }
    NetworkServices.previousStatus = ConnectionStatusEnum.Offline;
  }

  getToken(){
    return this.storage.get("loginDetails");
  }

  getUrl(url:string, val: any):string {
    return `${url}?api-token=${val.api_token}&user-id=${val.id}`;
  }

}

export class Response{
  status: string;
  message: string;
  data?: any;
  metadata?: any;
  complaintTypeList?: any;
}



// WEBPACK FOOTER //
// ./src/services/network-services.ts